<template>
  <div class="flex-cc flex-auto dir-col">
    <SuccessRedirect />
  </div>
</template>

<script>
  import SuccessRedirect from '@/components/successRedirect/SuccessRedirect';

  export default {
    components: { SuccessRedirect },
  }
</script>
